/**
 * Shared display helpers for movement types and stock levels.
 * Extracted from Dashboard/Movements/Inventory to avoid nested ternaries.
 */

const MOVEMENT_CLASSES = {
  giris: "bg-[color:var(--success-bg)] text-[color:var(--success)]",
  cikis: "bg-[color:var(--error-bg)] text-[color:var(--error)]",
  transfer: "bg-[color:var(--accent-bg)] text-[color:var(--accent)]",
  silme: "bg-[color:var(--bg)] text-[color:var(--text-2)]",
};

const MOVEMENT_LABELS = {
  giris: "GİRİŞ",
  cikis: "ÇIKIŞ",
  transfer: "TRANSFER",
  silme: "SİLME",
};

const ACCENT_CLASSES = {
  accent: "bg-[color:var(--accent-bg)] text-[color:var(--accent)]",
  success: "bg-[color:var(--success-bg)] text-[color:var(--success)]",
  warning: "bg-[color:var(--warning-bg)] text-[color:var(--warning)]",
};

export function movementBadgeClass(type) {
  return MOVEMENT_CLASSES[type] || "bg-[color:var(--bg)] text-[color:var(--text-2)]";
}

export function movementLabel(type) {
  return MOVEMENT_LABELS[type] || type;
}

export function accentIconClass(accent) {
  return ACCENT_CLASSES[accent] || "bg-[color:var(--bg)] text-[color:var(--primary)]";
}

export function stockLevelClass(adet) {
  if (adet === 0) return "text-[color:var(--text-3)]";
  if (adet <= 2) return "text-[color:var(--warning)]";
  return "text-[color:var(--text)]";
}

// Parse "500x1200" / "500 X 1200" / "500×1200" → { w, h } in mm.
export function parseEbatDims(ebat) {
  if (!ebat) return null;
  const m = /(\d{2,5})\s*[xX×]\s*(\d{2,5})/.exec(String(ebat));
  if (!m) return null;
  return { w: parseInt(m[1], 10), h: parseInt(m[2], 10) };
}

// Thickness in mm, extracted from product name (e.g. "6 mm Float").
export function parseThicknessMm(isim) {
  if (!isim) return 0;
  const m = /(\d+(?:[.,]\d+)?)\s*mm\b/i.exec(String(isim));
  if (!m) return 0;
  return parseFloat(m[1].replace(",", "."));
}

// Per-row m² and kg based on ebat (mm) × adet × thickness.
// kg density factor 2.5 kg/m²/mm matches the backend order-slip formula.
export function computeM2Kg(item) {
  const dims = parseEbatDims(item?.ebat);
  const thickness = parseThicknessMm(item?.isim);
  const adet = Number(item?.adet || 0);
  const m2PerBlock = dims ? (dims.w * dims.h) / 1_000_000 : 0;
  const m2 = +(m2PerBlock * adet).toFixed(2);
  const kg = thickness ? +(m2PerBlock * thickness * 2.5 * adet).toFixed(1) : 0;
  return { m2, kg, hasDims: !!dims, hasThickness: thickness > 0 };
}
